import { useContext, useEffect } from 'react'
import { AuthContext } from 'contexts/AuthContext'
import { AppContext } from 'contexts/AppContext'
import { Button } from 'keep-react'

export const AccessModeSelection = () => {
  const { currentUser, setCurrentBroker, brokerContacts } =
    useContext(AuthContext)
  const { setShowAccessMode } = useContext(AppContext)

  useEffect(() => {
    if (!currentUser || !brokerContacts) return
  }, [])

  if (brokerContacts && brokerContacts.length === 1) {
    setCurrentBroker(brokerContacts[0])
    setShowAccessMode(false)
    return <></>
  } else {
    if (!currentUser || !brokerContacts) return <></>
    else {
      return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[9999]">
          <div className="bg-white p-4 rounded-lg shadow-lg text-center w-[400px] relative z-[10000]">
            <h2 className="text-primary-700 font-bold text-lg mb-4">
              EM QUE MODO DESEJA ACEDER?
            </h2>

            <div className="space-y-2 max-h-96 overflow-y-auto">
              {brokerContacts &&
                brokerContacts.map(broker => (
                  <Button
                    key={broker.BrokerNo}
                    variant="default"
                    color={broker.IsGroup === true ? 'secondary' : 'primary'}
                    className={`w-full py-2 px-4 rounded-md white justify-start truncate`}
                    onClick={() => {
                      setCurrentBroker(broker)
                      setShowAccessMode(false)
                    }}
                  >
                    {broker.BrokerName}
                  </Button>
                ))}
            </div>
          </div>
        </div>
      )
    }
  }
}
